import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[appGridItem]',
    standalone: false
})
export class GridItemDirective {

  @Input() public column?: number;
  @Input() public row?: number;
  @Input() public width?: number;
  @Input() public height?: number;

  @HostBinding('style.grid-column')
  protected get gridColumn(): string {
    return `${this.startColumn} / ${this.endColumn}`;
  }

  @HostBinding('style.grid-row')
  protected get gridRow(): string {
    return `${this.startRow} / ${this.endRow}`;
  }

  private get startColumn(): number {
    return this.column ?? 1;
  }

  private get startRow(): number {
    return this.row ?? 1;
  }

  private get endColumn(): number {
    return this.startColumn + (this.width ?? 0);
  }

  private get endRow(): number {
    return this.startRow + (this.height ?? 0);
  }

}
